





































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class JobNewHeaderInputField extends Vue {
  @Prop(String) private onChangeView!: string;
  @Prop(String) private occupation!: string;

  private isOpenUpdateHeaderPhotoModal: boolean = false;

  // ヘッダーファイル選択ボタン
  private openHeaderExplorer(): void {
    const headerExplorer = this.$refs.headerExplorer as HTMLElement;
    headerExplorer.click();
  }

  private readHeaderImage(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (!files!.length) {
      this.isOpenUpdateHeaderPhotoModal = false;
      return;
    }
    const reader = new FileReader();
    this.isOpenUpdateHeaderPhotoModal = true;
    reader.readAsDataURL(files![0]);
  }
}
